// @flow

import * as React from 'react';
import { Cookies, withCookies } from 'react-cookie';
import { cookieDefaultDate, currenciesSymbols } from '../../const';

type Props = {
  cookieToSet: string,
  title: string,
  values: string[],
  cookies: Cookies,
}

class CookieSelector extends React.Component<Props> {
  handleClick = (cookieToSet: string, value: string) => {
    this.props.cookies.set(
      cookieToSet,
      value,
      { expires: cookieDefaultDate, Path: '/' },
    );
  };

  render() {
    return (
      <div
        className="selector"
      >
        {this.props.title}
        <div className="selector-list">
          {
            this.props.values
              .map(value => (
                <button
                  id={value}
                  key={value}
                  name={value}
                  value={value}
                  onClick={() => this.handleClick(this.props.cookieToSet, value)}
                  className={`selector-buttons ${this.props.cookies.get(this.props.cookieToSet) === value ? 'selected' : ''}`}
                >
                  {currenciesSymbols[value]}
                </button>
              ))
          }
        </div>
      </div>
    );
  }
}

export default withCookies(CookieSelector);
